"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
function BlogPostsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="space-y-4">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex gap-4">
            <div className="h-24 w-32 shrink-0 rounded-[var(--radius-md)] bg-muted/30 animate-pulse" />
            <div className="flex-1 space-y-2">
              <div className="h-5 w-3/4 rounded bg-muted/30 animate-pulse" />
              <div className="h-4 w-full rounded bg-muted/30 animate-pulse" />
              <div className="h-4 w-5/6 rounded bg-muted/30 animate-pulse" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-muted-foreground">
        Failed to load blog posts.
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground">No blog posts to display.</p>;
  }
  return <div className="space-y-4">
      {posts.slice(0, 3).map((post, i) => <Card key={post.id} data-index={i} className="group card hover-lift overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
          <Link to={post.link || "#"} className="flex gap-4 p-4">
            {post.featuredImage && <div className="h-24 w-32 shrink-0 overflow-hidden rounded-[var(--radius-sm)]">
                <img src={post.featuredImage} alt={post.title} className="size-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:scale-[1.02]" />
              </div>}
            <div className="flex-1 min-w-0">
              <h3 className="font-display text-base font-semibold leading-tight line-clamp-2 mb-2">
                {post.title}
              </h3>
              {post.excerpt && <p className="text-sm text-muted-foreground line-clamp-2">
                  {post.excerpt}
                </p>}
            </div>
          </Link>
        </Card>)}
    </div>;
}
export default function FeaturedBlog() {
  return <section id="featured-blog" className="dark bg-background text-foreground section-dark px-4">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_auto] lg:gap-12">
          <PostsProvider className="flex flex-col" wp_query={{
          per_page: 3,
          order: "desc",
          orderby: "date"
        }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "_embedded", "_links.wp:featuredmedia"]}>
            <BlogPostsConsumer />
          </PostsProvider>

          <div className="flex items-center justify-center lg:justify-start">
            <div className="sticky top-1/2 -translate-y-1/2">
              <Link to="/BlogPage">
                <Button size="lg" className="btn-primary px-8 py-4 text-base font-semibold shadow-[var(--shadow-medium)]">
                  Read All Articles
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}